import React, { useEffect } from 'react';
import Modal from '@/components/modal/Modal.tsx';
import ModalHeader from '@/components/modal/ModalHeader.tsx';
import ModalContent from '@/components/modal/ModalContent.tsx';
import { Skeleton } from '@/components/ui/Skeleton.tsx';
import usePreviewConsent from '@/features/public/booking/hooks/usePreviewConsent.ts';
import { BookingSpecificationRequest } from '@/features/public/booking/types/BookingSpecificationRequest.ts';
import RichTextPreview from '@/components/richText/RichTextPreview.tsx';

const ConsentPreviewSkeleton = () => (
  <div className="space-y-3">
    <Skeleton className="h-5 w-3/4" />
    <Skeleton className="h-4 w-full" />
    <Skeleton className="h-4 w-full" />
    <Skeleton className="h-4 w-5/6" />
    <Skeleton className="h-5 w-1/2" />
    <Skeleton className="h-4 w-full" />
    <Skeleton className="h-4 w-4/5" />
  </div>
);

const ConsentPreviewModal = ({
  onClose,
  consentId,
  consentName,
  orgSlug,
  tourSlug,
  bookingSpecification,
}: {
  onClose: () => void;
  consentId: string;
  consentName: string;
  orgSlug: string;
  tourSlug: string;
  bookingSpecification: BookingSpecificationRequest;
}) => {
  const { mutate, data, isPending } = usePreviewConsent();

  useEffect(() => {
    mutate({ orgSlug, tourSlug, consentId, bookingSpecification });
  }, []);

  return (
    <Modal onClose={onClose}>
      <ModalHeader title={consentName} onClose={onClose} />
      <ModalContent>
        {isPending ? (
          <ConsentPreviewSkeleton />
        ) : (
          // Backend returns a self-contained document (own `<style>` +
          // `.cd-doc` wrapper) — render it as-is without re-wrapping.
          <RichTextPreview selfContained html={data?.html ?? ''} />
        )}
      </ModalContent>
    </Modal>
  );
};

export default ConsentPreviewModal;
